import { faker } from "@faker-js/faker";

import type {
  UpdateVendorContract200,
  UpdateVendorContractMutationRequest,
  UpdateVendorContractMutationResponse,
  UpdateVendorContractPathParams,
} from "../models/UpdateVendorContract";
import { createContract } from "./createContract";
import { createCreateOrUpdateVendorContractRequest } from "./createCreateOrUpdateVendorContractRequest";

export function createUpdateVendorContractPathParams(
  override: NonNullable<Partial<UpdateVendorContractPathParams>> = {},
): NonNullable<UpdateVendorContractPathParams> {
  return {
    ...{ vendor_id: faker.number.int(), id: faker.number.int() },
    ...override,
  };
}

/**
 * @description OK
 */
export function createUpdateVendorContract200(
  override: NonNullable<Partial<UpdateVendorContract200>> = {},
): NonNullable<UpdateVendorContract200> {
  return {
    ...{ contract: createContract() },
    ...override,
  };
}

export function createUpdateVendorContractMutationRequest(
  override?: NonNullable<Partial<UpdateVendorContractMutationRequest>>,
): NonNullable<UpdateVendorContractMutationRequest> {
  return createCreateOrUpdateVendorContractRequest(override);
}

/**
 * @description OK
 */
export function createUpdateVendorContractMutationResponse(
  override: NonNullable<Partial<UpdateVendorContractMutationResponse>> = {},
): NonNullable<UpdateVendorContractMutationResponse> {
  return {
    ...{ contract: createContract() },
    ...override,
  };
}
